import { render, staticRenderFns } from "./resize-bar.vue?vue&type=template&id=6844435b&scoped=true&"
import script from "./resize-bar.vue?vue&type=script&lang=js&"
export * from "./resize-bar.vue?vue&type=script&lang=js&"
import style0 from "./resize-bar.vue?vue&type=style&index=0&id=6844435b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844435b",
  null
  
)

export default component.exports